import type { PmMarkConverter } from './../pm-converters/types';
import { Decoration_Type } from './../ricos-schema/legacy/wix/rich_content/v1';

export const spoilerConverter: PmMarkConverter = {
  fromPm: {
    type: Decoration_Type.SPOILER,
    convert: () => {
      return [{ type: Decoration_Type.SPOILER }];
    },
  },
  toPm: {
    type: Decoration_Type.SPOILER,
    convert: () => {
      return { type: Decoration_Type.SPOILER };
    },
  },
};
